import { DocumentInfo } from 'api';
import { TextField } from 'form';
import { useTranslation } from 'i18n';
import { Box, Grid, SectionContainer } from 'ui';

import { AddDocumentInMemoryButton, DocumentList } from '../../../document';

type Props = {
  uploadedDocuments: DocumentInfo[];
};

export const BuyerAdditionalDetailsAndDocumentsSection = ({ uploadedDocuments }: Props) => {
  const { t } = useTranslation('orders');

  return (
    <>
      <SectionContainer title={t('buyerAdditionalDetailsAndDocumentsSection.title')}>
        <TextField
          name="external_reference_number"
          label={t('buyerAdditionalDetailsAndDocumentsSection.labels.purchaserExternalReferenceIndent')}
          type="text"
          fullWidth
          infoTooltip={t('buyerAdditionalDetailsAndDocumentsSection.tooltips.purchaserExternalReferenceIndent')}
        />
        <TextField
          name="comments"
          label={t('buyerAdditionalDetailsAndDocumentsSection.labels.commentsOnSalesOrder')}
          type="text"
          fullWidth
          minRows={2}
          multiline
          infoTooltip={t('buyerAdditionalDetailsAndDocumentsSection.tooltips.commentsOnSalesOrder')}
        />
        <TextField
          name="internal_notes"
          label={t('buyerAdditionalDetailsAndDocumentsSection.labels.internalNotes')}
          type="text"
          fullWidth
          minRows={2}
          multiline
          infoTooltip={t('buyerAdditionalDetailsAndDocumentsSection.tooltips.internalNotes')}
        />
      </SectionContainer>
      <Box>
        <Grid container spacing={2}>
          <Grid
            size={{
              md: 4,
              xs: 12,
            }}
          >
            <AddDocumentInMemoryButton name="documents" />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          sx={{
            pt: 4,
          }}
        >
          <Grid
            size={{
              md: 4,
              xs: 12,
            }}
          >
            <DocumentList name="documents" uploadedDocuments={uploadedDocuments} />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
